// src/lib/withTriggerCombobox.ts
import {
  getEditorString,
  getPointBefore,
  getRange
} from "@udecode/plate-common";
var withTriggerCombobox = ({ editor, getOptions, type }) => {
  const { insertText } = editor;
  const matchesTrigger = (text) => {
    const { trigger } = getOptions();
    if (trigger instanceof RegExp) {
      return trigger.test(text);
    }
    if (Array.isArray(trigger)) {
      return trigger.includes(text);
    }
    return text === trigger;
  };
  editor.insertText = (text) => {
    const { createComboboxInput, triggerPreviousCharPattern, triggerQuery } = getOptions();
    if (!editor.selection || !matchesTrigger(text) || triggerQuery && !triggerQuery(editor)) {
      return insertText(text);
    }
    const previousChar = getEditorString(
      editor,
      getRange(
        editor,
        editor.selection,
        getPointBefore(editor, editor.selection)
      )
    );
    const matchesPreviousCharPattern = triggerPreviousCharPattern == null ? void 0 : triggerPreviousCharPattern.test(previousChar);
    if (matchesPreviousCharPattern) {
      const inputNode = createComboboxInput ? createComboboxInput(text) : { children: [{ text: "" }], type };
      return editor.insertNode(inputNode);
    }
    return insertText(text);
  };
  return editor;
};

// src/lib/utils/filterWords.ts
var filterWords = (haystack, needle, {
  prefixMode = "last-word",
  wordBoundary = /\s+/,
  wordQuantifier = "match-all"
} = {}) => {
  const haystackWords = haystack.trim().split(wordBoundary);
  const needleWords = needle.trim().split(wordBoundary);
  const quantifier = wordQuantifier === "match-all" ? "every" : "some";
  return needleWords[quantifier]((needleWord, i) => {
    const allowPrefix = (() => {
      switch (prefixMode) {
        case "none": {
          return false;
        }
        case "all-words": {
          return true;
        }
        case "last-word": {
          return i === needleWords.length - 1;
        }
      }
    })();
    return haystackWords.some((unslicedHaystackWord) => {
      const haystackWord = allowPrefix ? unslicedHaystackWord.slice(0, needleWord.length) : unslicedHaystackWord;
      return haystackWord.localeCompare(needleWord, void 0, {
        sensitivity: "base",
        usage: "search"
      }) === 0;
    });
  });
};
export {
  filterWords,
  withTriggerCombobox
};
//# sourceMappingURL=index.mjs.map